export enum USER_ACTION {
    APPROVE = 'approve',
    DISAPPROVE = 'disapprove',
    EDIT = 'edit',
    BLOCK = 'block',
    SHOW_DETAILS = 'show_details',
    RESEND_CONFIRMATION_EMAIL = 'resend_confirmation_email',
}
